import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { ExternalLink, Loader2, Save } from "lucide-react";
import { api } from "../lib/api";
import { fmtDate } from "../lib/format";
import { Button } from "./ui/button";
import RichTextEditor from "./RichTextEditor";

const PAGES = [
  { kind: "terms", label: "Termini e Condizioni", path: "/terms" },
];

export default function LegalPagesEditor() {
  const [kind, setKind] = useState("terms");
  const [html, setHtml] = useState("");
  const [updatedAt, setUpdatedAt] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const page = PAGES.find((p) => p.kind === kind);

  useEffect(() => {
    setLoading(true);
    api.get(`/public/legal/${kind}`)
      .then(({ data }) => { setHtml(data.html || ""); setUpdatedAt(data.updated_at); })
      .catch(() => toast.error("Impossibile caricare il testo"))
      .finally(() => setLoading(false));
  }, [kind]);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put(`/super-admin/legal/${kind}`, { html });
      setUpdatedAt(data.updated_at);
      toast.success(`${page.label} pubblicata`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Salvataggio non riuscito");
    } finally { setSaving(false); }
  };

  return (
    <div data-testid="legal-pages-editor" className="space-y-4">
      <div className="flex flex-wrap items-center gap-2">
        {PAGES.map((p) => (
          <button key={p.kind} type="button" data-testid={`legal-editor-select-${p.kind}`} onClick={() => setKind(p.kind)}
            className={`px-4 h-9 rounded-full text-sm font-semibold transition-colors ${kind === p.kind ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}>
            {p.label}
          </button>
        ))}
      </div>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="text-sm text-slate-500" data-testid="legal-editor-updated">
          {updatedAt ? `Ultima pubblicazione: ${fmtDate(updatedAt)}` : "Non ancora pubblicata: la pagina mostra \"Contenuto in preparazione\"."}
        </p>
        <div className="flex gap-2">
          <a href={page.path} target="_blank" rel="noreferrer" data-testid="legal-editor-view-link"
            className="inline-flex items-center gap-1.5 h-9 px-3 rounded-md border border-slate-200 text-sm text-slate-600 hover:bg-slate-50">
            <ExternalLink style={{ width: 14, height: 14 }} /> Vedi pagina
          </a>
          <Button onClick={save} disabled={saving || loading} data-testid="legal-editor-save-btn" className="gap-1.5">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Pubblica
          </Button>
        </div>
      </div>
      {loading ? (
        <div className="py-20 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>
      ) : (
        <RichTextEditor key={kind} value={html} onChange={setHtml} testId={`legal-editor-${kind}`} />
      )}
      <p className="text-xs text-slate-400">Puoi incollare testo da Word o da un generatore di policy: titoli, grassetto ed elenchi vengono mantenuti. Lasciando il testo vuoto la pagina torna a "Contenuto in preparazione".</p>
    </div>
  );
}
